import { mainApi } from '../index';
import type { GoogleCalendarsResponse, UpdateCalendarsRequest } from './types';

/**
 * Get all available Google calendars
 */
export async function getAllGoogleCalendars(): Promise<GoogleCalendarsResponse> {
    const response = await mainApi.get('v1/integrations/google-calendar/all-calendars');
    return response.data;
}

/**
 * Update Google Calendar settings (selected calendars)
 */
export async function updateGoogleCalendars(data: UpdateCalendarsRequest): Promise<void> {
    await mainApi.post('v1/integrations/google-calendar/calendars', data);
}

/**
 * Migrate old calendar data to new format
 */
export async function migrateGoogleCalendarData(): Promise<void> {
    await mainApi.post('v1/integrations/google-calendar/calendars/migrate');
}
